











































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { SummaryOrderModel } from '@/models/summary-order';

@Component
export default class SummaryOrder extends Vue {
    @Prop({default: null})
    private summaryOrder!: SummaryOrderModel;

    @Prop({default: null})
    private selectedStatus!: any;

    private isCollapse: boolean = true;

    private async onCollapse() {
        this.isCollapse = !this.isCollapse;
    }
}
